
<!--  -->
<template>
  <div class>
    <div
      style="
        padding: 30px;
        background: #ffffff;
        box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
        border-radius: 10px;
      "
    >
      <div class>
        <span
          style="
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #343434;
          "
          >安全设置</span
        >
      </div>
      <div class="Itemwrap">
        <div class="Itemlist">
          <div class="LR_center">
            <div class="LR_center">
              <div>
                <i
                  class="el-icon-success"
                  style="color: #67c23a; font-size: 20px"
                ></i>
              </div>
              <div class="count_center" style="margin-left: 10px">
                <div>登录密码</div>
                <div style="color: #999">
                  {{ this.Authorization.username }}（{{
                    this.Authorization.namec
                  }}）
                </div>
              </div>
            </div>
            <div>
              <el-button type="text" @click="deitPaword()">修改</el-button>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
        <!-- item-end -->
        <div class="Itemlist">
          <div class="LR_center">
            <div class="LR_center">
              <div>
                <i
                  class="el-icon-success"
                  style="color: #67c23a; font-size: 20px"
                ></i>
              </div>
              <div class="count_center" style="margin-left: 10px">
                <div>手机号码</div>
                <div v-if="Authorization.phoneNo" style="color: #999">
                  您已绑定了手机
                  <span style="color: #f56c6c">{{
                    this.Authorization.phoneNo
                  }}</span>
                  可以使用手机号登录
                </div>
                <div v-else style="color: #999">暂未绑定手机</div>
              </div>
            </div>
            <div>
              <el-button type="text" @click="teldialog()">修改</el-button>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
        <!-- item-end -->
        <div class="Itemlist">
          <div class="LR_center">
            <div class="LR_center">
              <div>
                <i
                  v-if="!Authorization.isBindedWebOpenId"
                  class="el-icon-warning"
                  style="color: #f56c6c; font-size: 20px"
                ></i>
                <i
                  v-else
                  class="el-icon-success"
                  style="color: #67c23a; font-size: 20px"
                ></i>
              </div>
              <div class="count_center" style="margin-left: 10px">
                <div v-if="!Authorization.isBindedWebOpenId">
                  <div>
                    <span style="color: #f56c6c">[未绑定]</span>
                    <span>绑定微信</span>
                  </div>
                  <div style="color: #999">
                    绑定后通过微信扫一扫快速扫码登录，以及在微信上接收订单最新的物流状态推送
                  </div>
                </div>
                <div v-else>
                  <div>
                    <span>绑定微信</span>
                  </div>
                  <div>
                    您已绑定了微信
                    <span style="color: #FF4D01">{{
                      Authorization.nickname
                    }}</span>
                    绑定后通过微信扫一扫快速扫码登录，以及在微信上接收订单最新的物流状态推送
                  </div>
                </div>
              </div>
            </div>
            <div>
              <el-button
                type="text"
                @click="
                  !Authorization.isBindedWebOpenId ? BindedWx() : relieve()
                "
                >{{
                  !Authorization.isBindedWebOpenId ? "去绑定" : "解绑"
                }}</el-button
              >
            </div>
          </div>
          <el-divider></el-divider>
        </div>
        <!-- item-end -->
        <!-- item-end -->
        <div class="Itemlist">
          <div class="LR_center">
            <div class="LR_center">
              <div>
                <i
                  v-if="authenticationInfoDTO.state !== 3"
                  class="el-icon-warning"
                  style="color: #f56c6c; font-size: 20px"
                ></i>
                <i
                  v-if="authenticationInfoDTO.state == 3"
                  class="el-icon-success"
                  style="color: #67c23a; font-size: 20px"
                ></i>
              </div>
              <div class="count_center" style="margin-left: 10px">
                <div>
                  <div>
                    <span
                      style="color: #f56c6c"
                      v-if="authenticationInfoDTO.state !== 3"
                      >{{
                        authenticationInfoDTO.state == -1
                          ? "[未认证]"
                          : authenticationInfoDTO.state == 1
                          ? "[已提交相关资料，审核中]"
                          : authenticationInfoDTO.state == 2
                          ? "[认证失败]"
                          : "已认证"
                      }}</span
                    >
                    <span>实名认证</span>
                  </div>
                  <div style="color: #999">
                    {{authenticationInfoDTO.type == 7 ? '想要下单需升级成为销售代理' : '自主上传认证资料可提高开户效率，方便快速出货'}}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <el-button
                type="text"
                @click="setSenk(authenticationInfoDTO.type == 7 ? -1 : authenticationInfoDTO.state)"
                >{{
                  authenticationInfoDTO.type == 7
                    ? "升级身份"
                    : authenticationInfoDTO.state == -1
                    ? "去认证"
                    : authenticationInfoDTO.state == 1
                    ? "查看认证资料"
                    : authenticationInfoDTO.state == 2
                    ? "重新认证"
                    : "查看认证资料"
                }}</el-button
              >
            </div>
          </div>
          <el-divider></el-divider>
        </div>
        <!-- item-end -->

        <div class="Itemlist">
          <div class="LR_center">
            <div class="LR_center">
              <div>
                <i
                  v-if="Authorization.email"
                  class="el-icon-success"
                  style="color: #67c23a; font-size: 20px"
                ></i>
                <i
                  v-else
                  class="el-icon-warning"
                  style="color: #f56c6c; font-size: 20px"
                ></i>
              </div>
              <div class="count_center" style="margin-left: 10px">
                <div v-if="Authorization.email" style="color: #999">
                  <div style="color:#333">邮箱</div>
                  您已绑定了邮箱
                  <span style="color: #f56c6c">{{
                    this.Authorization.email
                  }}</span>
                  ，订阅国家或者产品线路后，价格变动或者国家渠道变动会第一时间会推送给您
                </div>
                <div v-else>
                  <div style="color: #999">
                    <div>
                      <span style="color:#f56c6c">[未绑定]</span>
                      <span style="color:#333">绑定邮箱</span>
                    </div>
                  绑定后可接收已订阅国家及产品线路的价格变动或者国家渠道变动的推送通知
                  </div>
                </div>
              </div>
            </div>
            <div>
              <el-button type="text" @click="emailDialogVisibleBtn()">{{
                Authorization.email ? "修改" : "去绑定"
              }}</el-button>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
        <!-- item-end -->
      </div>
    </div>

    <!-- 修改登录密码 -->
    <el-dialog
      center
      title="修改登录密码"
      width="500px"
      :visible.sync="dialogFormVisible"
    >
      <div style="padding: 0 50px">
        <el-form label-position="left" size="mini" :model="eatiFrom">
          <el-form-item label="当前手机号" :label-width="formLabelWidth">
            <el-input
              disabled
              v-model="eatiFrom.tel"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" :label-width="formLabelWidth">
            <el-input
              placeholder="验证码"
              auto-complete="new-password"
              v-model="eatiFrom.code"
            >
              <el-button @click="sendCode1" slot="append">{{
                countDown > 0 ? countDown : "获取验证码"
              }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="新密码" :label-width="formLabelWidth">
            <el-input
              show-password
              v-model="eatiFrom.password"
              auto-complete="new-password"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" :label-width="formLabelWidth">
            <el-input
              show-password
              v-model="eatiFrom.newpassword"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="Qdpasword()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改手机号码 -->
    <el-dialog
      center
      title="修改手机号码"
      width="500px"
      :visible.sync="telShow"
    >
      <div style="padding: 0 50px">
        <el-form label-position="left" size="mini" :model="eatTel">
          <el-form-item label="当前手机号" :label-width="formLabelWidth">
            <el-input
              disabled
              v-model="eatTel.userTel"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item label="新手机号" :label-width="formLabelWidth">
            <el-input v-model="eatTel.newTel" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="验证码" :label-width="formLabelWidth">
            <el-input placeholder="验证码" v-model="eatTel.code">
              <el-button @click="sendCode2" slot="append">{{
                countDownT > 0 ? countDownT : "获取验证码"
              }}</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Qdnewtel()">确认修改</el-button>
      </div>
    </el-dialog>
    <!-- 二维码弹窗 -->
    <div class="show-code">
      <el-dialog
        title="扫码绑定微信"
        :visible.sync="centerDialogVisible"
        width="30%"
        center
      >
        <span>
          <div class="tips"></div>
          <div class="login-wx-code">
            <div id="wx_login_container_3"></div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 查看认证弹窗 -->
    <div class="dialogwrap">
      <el-dialog :visible.sync="SeeImg" width="657px">
        <el-dialog width="700px" :visible.sync="innerVisible" append-to-body>
          <div>
            <img style="width: 100%; height: 100%" :src="setUrl" alt="" />
          </div>
        </el-dialog>
        <div class="dialogCenter">
          <p style="text-align: center; font-size: 18px; font-weight: bold">
            {{
              authenticationInfoDTO.type == 1 ? "企业认证资料" : "个人认证资料"
            }}
          </p>
          <p style="text-align: center; margin-top: 30px">
            {{
              authenticationInfoDTO.type == 1
                ? "公司营业执照"
                : "本人有效身份证"
            }}
          </p>
          <div
            v-if="authenticationInfoDTO.type == 1"
            style="margin-top: 52px; cursor: pointer"
          >
            <img
              @click="(innerVisible = true), (setUrl = LicImgurl)"
              class="setImg"
              style="width: 183px"
              :src="LicImgurl"
              alt=""
            />
          </div>
          <div v-else class="LR_center" style="margin-top: 52px">
            <div style="margin: 0 15px; cursor: pointer">
              <img
                @click="(innerVisible = true), (setUrl = sfzzImgurl)"
                class="setImg"
                style="width: 188px"
                :src="sfzzImgurl"
                alt=""
              />
            </div>
            <div style="margin: 0 15px; cursor: pointer">
              <img
                @click="(innerVisible = true), (setUrl = sfzfImgurl)"
                class="setImg"
                style="width: 188px"
                :src="sfzfImgurl"
                alt=""
              />
            </div>
          </div>
          <div class="dialogCenter" style="margin-top: 40px">
            <div
              v-if="authenticationInfoDTO.state !== 3"
              style="margin-top: 12px; color: #999999"
            >
              照片支持JPEG、JPG、PNG格式，最大文件不超过2M。
            </div>
            <div class="LR_center" style="margin-top: 34px">
              <i
                v-if="authenticationInfoDTO.state !== 3"
                class="el-icon-warning"
                style="color: #f56c6c; font-size: 20px"
              ></i>
              <i
                v-if="authenticationInfoDTO.state == 3"
                class="el-icon-success"
                style="color: #67c23a; font-size: 20px"
              ></i>
              <span style="margin-left: 5px">{{
                authenticationInfoDTO.state == -1
                  ? "未认证"
                  : authenticationInfoDTO.state == 1
                  ? "已提交相关资料，审核中"
                  : authenticationInfoDTO.state == 2
                  ? "认证失败"
                  : "已认证"
              }}</span>
            </div>
            <div class="LR_center" style="padding: 19px 0">
              <el-button @click="SeeImg = false">关闭</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 邮箱弹窗 -->
    <el-dialog title="绑定邮箱" :visible.sync="emailDialogVisible" width="30%" :close-on-click-modal="false" @close="emailDiaologClose">
      <div
        v-if="
          this.Authorization.email == '' || this.Authorization.email == null
        "
      >
        <el-form
          :model="numberValidateForm"
          ref="numberValidateForm"
          label-width="100px"
          class="demo-ruleForm"
          :hide-required-asterisk="true"
        >
          <el-form-item
            label="邮箱"
            prop="email"
            :rules="[
              { required: true, message: '请输入邮箱' },
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input
              style="width: 70%"
              v-model="numberValidateForm.email"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="emailCode" :rules="[{ required: true, message: '请输入验证码' }]">
            <el-input v-model="numberValidateForm.emailCode" style="width: 70%">
              <el-button @click="sendCodeByEmail('numberValidateForm')" slot="append">{{
                  emailCountDown > 0 ? emailCountDown : "获取验证码"
                }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('numberValidateForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('numberValidateForm')"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <div v-else>
        <el-form
          :model="emailValidateForm"
          ref="emailValidateForm"
          label-width="100px"
          class="demo-ruleForm"
          :hide-required-asterisk="true"
        >
          <el-form-item label="旧邮箱">
            <el-input
              style="width: 70%"
              v-model="emailValidateForm.email"
              autocomplete="off"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="新邮箱"
            prop="NewEmail"
            :rules="[
              { required: true, message: '请填写新邮箱' },
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input
              style="width: 70%"
              v-model="emailValidateForm.NewEmail"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="emailCode" :rules="[{ required: true, message: '请输入验证码' }]">
            <el-input v-model="emailValidateForm.emailCode" style="width: 70%">
              <el-button @click="sendCodeByEmail('emailValidateForm')" slot="append">{{
                  emailCountDown > 0 ? emailCountDown : "获取验证码"
                }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetNewForm('emailValidateForm')"
              >取消</el-button
            >
            <el-button
              type="primary"
              @click="submitNewForm('emailValidateForm')"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 选择实名认证类型 start -->
    <real-name-type-select
      :show="selectRealnameTypeShow"
      @toRealName="showRealNameDialog"
      @close="selectRealnameTypeClose"
      :type="realNameType">
    </real-name-type-select>
    <!-- 选择实名认证类型 end -->

    <!-- 实名认证 start -->
    <UserManageinfo
      :dialogTableVisible="dialogTableVisible"
      @closedialog="closedialog"
      @getUserLoginInfo="getUserLoginInfo"
      ref="mychild"
      :realNameType="authType"
    ></UserManageinfo>
    <!-- 实名认证-End -->

    <el-dialog
      :title="realNameAuthenticationTitle"
      :visible.sync="visibleRealNameAuthentication"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="540px"
      @close="hideRealNameAuthentication"
    >
      <real-name-authentication-partner
        ref="authenticationPartner"
        :partner-type="authenticationType === 2 ? 2 : (checkAuthenticationType ? checkAuthenticationType : 1)"
        @success="realNameAuthenticationSuccess"
      />
    </el-dialog>
    <el-dialog
      :title="'查看'+realNameAuthenticationTitle+'资料'"
      :visible.sync="visibleViewRealNameAuthenticationInfo"
      :close-on-press-escape="false"
      :close-on-click-modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="540px"
      @close="hideRealNameAuthentication"
    >
      <view-real-name-authentication-partner-info
        :partner-type="authenticationType === 2 ? 2 : 1"
        :file-list="Authorization.authenticationInfoDTO && Authorization.authenticationInfoDTO.fileUrls || []"
      />
    </el-dialog>
  </div>
</template>
<script>
import qs from "qs";
import { loginSaveUserData } from "@/assets/js/utils.login";
import {mapGetters, mapState} from "vuex";
import RealNameAuthenticationPartner
  from "@/components/PersonalCenter/accountManage/realNameAuthentication/realNameAuthenticationPartner";
import ViewRealNameAuthenticationPartnerInfo
  from "@/components/PersonalCenter/accountManage/realNameAuthentication/viewRealNameAuthenticationPartnerInfo";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    ViewRealNameAuthenticationPartnerInfo,
    RealNameAuthenticationPartner,
    UserManageinfo: () => import("./UserManageinfo/UserManageinfo.vue"),
    realNameTypeSelect: () => import("../components/real-name-type-select.vue")
  },
  data() {
    //这里存放数据
    return {
      innerVisible: false,
      setUrl: "",
      SeeImg: false,
      centerDialogVisible: false,
      authenticationInfoDTO: {},
      eatiFrom: {
        tel: "",
        code: "",
        password: "",
        newpassword: "",
      },
      telShow: false,
      eatTel: {
        userTel: "",
        newTel: "",
        code: "",
      },
      formLabelWidth: "100px",
      dialogFormVisible: false,
      // password: "123",
      // username: "test_0006",
      //   密码修改
      newPwd: "",
      newPwdConfirm: "",
      oldPwd: "",
      userInfo: {},
      countDown: 0,
      //   修改手机号
      phone: "",
      newPhone: "",
      code: "",
      phoneNo: "",
      // 查看 实名认证资料 弹窗
      dialogTableVisible: false,
      LicImgurl: "",
      sfzzImgurl: "",
      sfzfImgurl: "",
      countDownT: 0,
      emailDialogVisible: false,
      numberValidateForm: {
        email: "",
        emailCode: "",
      },
      emailValidateForm: {
        email: "",
        NewEmail: "",
        emailCode: ""
      },
      emailCountDown: 0,
      timerE: null,
      // 选择实名认证类型 弹窗
      selectRealnameTypeShow: false,
      // 实名认证弹窗（合伙人）
      visibleRealNameAuthentication:false,
      realNameAuthenticationTitle:"城市合伙人认证",
      // 查看合伙人实名认证弹窗已提交资料
      visibleViewRealNameAuthenticationInfo:false,
      selectRealNameTypeCode: null,
      checkAuthenticationType: null
    };
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState(["Authorization"]),
    ...mapGetters(["realNameType","realNameState","authenticationType"]),

    authType() {
      if (this.realNameType && this.realNameType != -1 &&  this.realNameType != 7) {
        return this.realNameType
      } else if (this.selectRealNameTypeCode) {
        return this.selectRealNameTypeCode
      } else return null
    }
  },
  //监控data中的数据变化
  watch: {
    countDown(val) {
      if (val <= 0) {
        clearInterval(this.timer);
      }
    },
    countDownT(val) {
      if (val <= 0) {
        clearInterval(this.timerT);
      }
    },
    emailCountDown(val) {
      if (val <= 0) {
        clearInterval(this.timerE);
      }
    }
  },
  //方法集合
  methods: {
    relieve() {
      this.$confirm("确定解绑该微信吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let user = this.sessionGetUserInfo();
          this.$http
            .get("/wechatUser/unbindWechatQrCode", {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                token: user.token,
              },
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.info(res.data.message);
                return;
              }
              // this.$message(res.data.message);

              this.Authorization.isBindedWebOpenId = false;
              this.getUserLoginInfo();
              console.log("Authorization", JSON.stringify(Authorization));
              this.$message({
                message: "成功",
                type: "success",
              });
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {});
    },
    getUserLoginInfo() {
      let user = this.sessionGetUserInfo();
      this.$http
        .get("/user/getUserLoginInfo/1", {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            token: user.token,
          },
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.info(res.data.message);
            return;
          }
          loginSaveUserData(res.data.data);
          this.authenticationInfoDTO = res.data.data.authenticationInfoDTO;
          console.log(
            "this.authenticationInfoDTO: ",
            this.authenticationInfoDTO
          );
          let userdata = res.data.data.authenticationInfoDTO;
          if (userdata.type == 1) {
            //企业
            this.LicImgurl = userdata.fileUrls[0] || "";
          } else {
            //个人
            this.sfzzImgurl = userdata.fileUrls[0] || "";
            this.sfzfImgurl = userdata.fileUrls[1] || "";
          }
          console.log("sessionGetUserInfo", res.data.data);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    /**
     * 显示实名认证提交弹窗
     * @param type  {number}  实名认证类型
     */
    showRealNameDialog(type, atype) {
      this.selectRealnameTypeClose()
      if(type === 6){
        // 城市合伙人
          this.checkAuthenticationType = atype
        this.showRealNameAuthentication()
      }else{
        // 其他销售代理等
        this.dialogTableVisible = true;
        this.$refs.mychild.parentHandleclick();
        this.selectRealNameTypeCode = type
      }

    },
    /**
     * 展示 选择实名认证类型 or 查看实名认证资料 弹窗
     * @param state {number}  认证状态
     */
    setSenk(state) {
      if (state == -1 || state == 2) {
        //认证
        if(this.realNameType === 6){
          // 城市合伙人
          this.showRealNameAuthentication()
        } else{
          // this.dialogTableVisible = true;
          this.selectRealnameTypeShow = true
          // this.$refs.mychild.parentHandleclick();
        }

      } else {
        //查看
        if(this.realNameType === 6){
          // 城市合伙人
          this.visibleViewRealNameAuthenticationInfo = true;
        }else{
          // this.SeeImg = true;
          this.dialogTableVisible = true;
          this.$refs.mychild.parentHandleclick();
        }

      }
    },
    /**
     * 关闭 选择实名认证类型 弹窗
     */
    selectRealnameTypeClose() {
      this.selectRealnameTypeShow = false
    },
    /**
     * 关闭 查看实名认证资料 弹窗
     */
    closedialog() {
      this.dialogTableVisible = false;
    },
    /**
     * 展示 实名认证(合伙人) 弹窗
     */
    showRealNameAuthentication(){
      let partnerType = this.authenticationType === 2 ? 2 : 1;
      if (this.checkAuthenticationType) partnerType = this.checkAuthenticationType
      let label = partnerType === 2 ? "个人申请" : "公司申请";
      let title = `城市合伙人入驻`;
      this.realNameAuthenticationTitle = title;
      this.visibleRealNameAuthentication = true;
    },
    /**
     * 隐藏 实名认证(合伙人) 弹窗
     */
    hideRealNameAuthentication(){
      let $authenticationPartner = this.$refs.authenticationPartner;
      if($authenticationPartner && $authenticationPartner.resetData) $authenticationPartner.resetData();
      this.visibleRealNameAuthentication = false;
    },
    /**
     * 实名认证(合伙人) 成功
     */
    realNameAuthenticationSuccess(){
      this.hideRealNameAuthentication();
      this.getUserLoginInfo();
    },

    BindedWx() {
      this.centerDialogVisible = true;
      this.handleCodeBindOne();
    },
    // 绑定二维码
    handleCodeBindOne() {
      this.axios.get("/wechatUser/qrCodeCreateBind").then((res) => {
        if (res.data.code === 200) {
          this.$nextTick(() => {
            let address = res.data.data.qrCode;
            var obj = new WxLogin({
              self_redirect: false,
              id: "wx_login_container_3",
              appid: res.data.data.appId,
              scope: "snsapi_login",
              redirect_uri: address,
              state: res.data.data.qrKey,
              style: "black",
              // href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZXsKICAgICB3aWR0aDogMTAwJTsgICAgICAgICAgIAp9", //https://某个域名下的css文件
              href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZXsNCiAgICAgd2lkdGg6IDI2MHB4OyAgICAgICAgICAgDQp9DQouaW1wb3dlckJveCAuc3RhdHVzIHsNCiAgICBwYWRkaW5nOiA3cHggMTRweDsNCiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7DQp9",
            });
          });
        } else {
          this.$message({ message: res.data.message, type: "error" });
        }
      });
    },
    Qdpasword() {
      if (!this.eatiFrom.code) return this.$message.info("请输入验证码");
      if (!this.eatiFrom.password) return this.$message.info("请输入新密码");
      if (!this.eatiFrom.newpassword)
        return this.$message.info("请再次输入新密码");
      if (this.eatiFrom.password != this.eatiFrom.newpassword)
        return this.$message.info("两次密码输入不一致，请重新输入");

      this.$http
        .post(
          "/user/updatePwd",
          qs.stringify({
            newPwd: this.eatiFrom.newpassword,
            smsCode: this.eatiFrom.code,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.info(res.data.message);
            return;
          }
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.dialogFormVisible = false;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    Qdnewtel() {
      //修改手机号码
      if (!this.eatTel.newTel) return this.$message.info("请输入新手机号");
      if (!this.eatTel.code) return this.$message.info("请输入验证码");
      this.$http
        .post(
          "/user/updateUserPhoneNo",
          qs.stringify({
            phoneNo: this.eatTel.newTel,
            smsCode: this.eatTel.code,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.info(res.data.message);
            return;
          }
          loginSaveUserData(res.data.data);
          this.$message({
            message: "绑定成功",
            type: "success",
          });
          this.telShow = false;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    teldialog() {
      this.eatTel.userTel = this.Authorization.phoneNo;
      this.telShow = true;
    },
    deitPaword() {
      this.dialogFormVisible = true;
      this.eatiFrom.tel = this.Authorization.phoneNo;
      this.eatiFrom.code = "";
      this.eatiFrom.password = "";
      this.eatiFrom.newpassword = "";
    },
    // end-----
    sendCode2() {
      if (!this.eatTel.newTel) return this.$message.info("请输入新手机号码");
      if (this.countDownT != 0)
        return this.$message.info("请" + this.countDownT + "秒后再发送");
      let user = this.sessionGetUserInfo();
      this.$http
        .get("/user/requestRegisterSmsCode/" + this.eatTel.newTel, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            token: user.token,
          },
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.info(res.data.message);
            return;
          }
          this.$message({
            message: "发送成功！",
            type: "success",
          });
          if (this.countDownT > 0) {
            return;
          }
          clearInterval(this.timerT);
          this.countDownT = 30;
          this.timerT = setInterval(() => {
            this.countDownT--;
            console.log(this.countDownT);
          }, 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 发送验证码
    sendCode1() {
      //修改密码获取code
      if (this.countDown != 0) {
        this.$message.info("请" + this.countDown + "秒后再发送");
        return;
      }
      let user = this.sessionGetUserInfo();
      this.$http
        .get("/user/requestValidateSmsCode/", {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            token: user.token,
          },
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.info(res.data.message);
            return;
          }
          this.$message({
            message: "发送成功！",
            type: "success",
          });
          if (this.countDown > 0) {
            return;
          }
          clearInterval(this.timer);
          this.countDown = 30;
          this.timer = setInterval(() => {
            this.countDown--;
            console.log(this.countDown);
          }, 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    async sendCodeByEmail(formName) {
      if (this.emailCountDown !== 0) {
        this.$message.info("请" + this.emailCountDown + "秒后再发送");
        return;
      }
      const prop = formName === 'emailValidateForm' ? 'NewEmail' : 'email'
      const err = await new Promise((resolve, reject) => {
        this.$refs[formName].validateField(prop, (err) => {
          resolve(err)
        })
      })
      if (err) return
      clearInterval(this.timerE);
      this.emailCountDown = 60;
      this.timerE = setInterval(() => {
        this.emailCountDown--;
      }, 1000);
      const email = this[formName][prop]
      const type = this.$store.state.Authorization.userIdentityType
      const res = await this.axios.get(`/api/user/sendCodeByEmail/${email}/${type}`)
      if (res.data.code === 200) {
        this.$message({
          message: "发送成功！",
          type: "success",
        });
      } else {
        this.$message({
          message: res.data.message,
          type: "error",
        });
        clearInterval(this.timerE);
        this.emailCountDown = 0
      }
    },
    //   密码修改
    submit() {
      if (!this.newPwd || !this.newPwdConfirm || !this.oldPwd) {
        this.$message.info("密码不能为空！");
      }

      if (this.newPwd != this.newPwdConfirm) {
        this.$message.info("确认密码不一样！");
      }
      let user = this.sessionGetUserInfo();

      this.axios
        .post(
          "/user/updatePwd",
          qs.stringify({ newPwd: this.newPwd, oldPwd: this.oldPwd }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          console.log(res);

          if (res.data.code != 200) {
            this.$message.info(res.data.message);
            return;
          }

          this.$message.info("修改" + res.data.message + "");
          this.oldPwd = "";
          this.newPwd = "";
          this.newPwdConfirm = "";

          // 清除token

          // setTimeout(function() {
          // 	uni.clearStorageSync()

          // 	uni.reLaunch({
          // 		url: '../user/mydata',

          // 		// complete() {
          // 		// 	this.loadin = false
          // 		// 	uni.showToast({
          // 		// 		title: '退出成功！'
          // 		// 	});
          // 		// }
          // 	})
          // }, 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    emailDialogVisibleBtn() {
      if (this.Authorization.email) {
        this.emailValidateForm.email = this.Authorization.email;
      }
      this.emailDialogVisible = true;
    },
    resetForm(formName) {
      this.emailDialogVisible = false;
      // this.$refs[formName].resetFields();
    },
    resetNewForm(formName) {
      this.emailDialogVisible = false;
      // this.$refs[formName].resetFields();
    },
    emailDiaologClose() {
      this.$refs.emailValidateForm.resetFields();
      this.$refs.numberValidateForm.resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            email: this.numberValidateForm.email,
            emailCode: this.numberValidateForm.emailCode
          };
          this.axios
            .get(`/api/user/updateUserEmailByEmailCode?email=${params.email}&emailCode=${params.emailCode}`)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.info(res.data.message);
                return;
              }
              loginSaveUserData(res.data.data);
              this.$message({
                message: "绑定成功",
                type: "success",
              });
              this.emailDialogVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitNewForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.emailValidateForm.email === this.emailValidateForm.NewEmail)
            return this.$message.info("两次邮箱输入一致，请重新输入");
          let params = {
            email: this.emailValidateForm.NewEmail,
            emailCode: this.emailValidateForm.emailCode
          };
          this.axios
            .get(`/api/user/updateUserEmailByEmailCode?email=${params.email}&emailCode=${params.emailCode}`)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.info(res.data.message);
                return;
              }
              loginSaveUserData(res.data.data);
              this.$message({
                message: "绑定成功",
                type: "success",
              });
              this.emailDialogVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getUserLoginInfo();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let user = this.sessionGetUserInfo();
    this.userInfo = user;
    this.phoneNo = user.phoneNo;
    if (this.$route.query.bindMsg) {
      this.$alert(this.$route.query.bindMsg, {
        confirmButtonText: "确定",
        callback: (action) => {},
      });
    }
  },
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.block {
  float: left;
  width: 100%;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.count_center {
  display: flex;
  display: -webkit-flex;
  /* align-items: center; */
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
.Itemwrap {
  padding: 20px 60px 20px 20px;
  box-sizing: border-box;
}
.login-wx-code {
  text-align: center;
  margin-top: -35px;
}
.dialogwrap >>> .el-dialog__body {
  padding: 0 20px !important;
}
.dialogwrap >>> .el-dialog__headerbtn {
  z-index: 99 !important;
}
.dialogCenter {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
</style>




// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/UserManage.vue